// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"f7","border":"f8"};